import { Button, Icon, Text } from '@/components'
import React from 'react'
import { useNavigation } from '@/app/hooks'

export default function MissingContentSection({
  title,
  subtitle,
  buttonText,
  onClick,
  iconComponent,
}: {
  title: string
  subtitle: string
  buttonText?: string
  onClick?: () => void
  iconComponent?: React.ReactNode
}) {
  return (
    <div className="mt-5 bg-themed-purple-100 rounded-2xl p-6 flex flex-col flex-1 items-center text-center">
      {iconComponent}
      <Text variant="h3" className="mt-4">
        {title}
      </Text>
      <Text variant="body2" className="mt-2">
        {subtitle}
      </Text>
      {buttonText && onClick && (
        <Button
          variant="primary"
          id="add-utility-info-btn"
          className="mt-4"
          onClick={onClick}
          small={true}
        >
          {buttonText}
        </Button>
      )}
    </div>
  )
}

// This particular instance was used multiple times, so I just keep it here
export const MissingContentSectionPlan = () => {
  const navigate = useNavigation()

  return (
    <MissingContentSection
      title="Add Your Plan Details"
      subtitle="Tell us about your rate plan so we can make sure we're saving you money."
      buttonText="Add Utility Plan"
      onClick={() => navigate.push('/connect-utility/plan')}
      iconComponent={<Icon name="MoneyInHand" />}
    />
  )
}
